import React, { useState } from 'react';
import MemberVoting from '../election-management/MemberVoting';
import { getUser } from '../../core/services/auth';

const whitelistedEmails = [
  'jcedb07@gmail.com',
  'abadCS@bsp.gov.ph',
  'abalosaa@bsp.gov.ph',
  'AbedejosIS@bsp.gov.ph',
  'AbejarCM@bsp.gov.ph',
  'AbellarRJ@bsp.gov.ph',
  'tabilla@bsp.gov.ph',
  'AbocadoMA@bsp.gov.ph',
  'CAbot@bsp.gov.ph',
  'AbrajanoSO@bsp.gov.ph',
  'bathanmc@bsp.gov.ph',
  'adanamv@bsp.gov.ph',
  'lafrica@bsp.gov.ph',
  'AganonCC@bsp.gov.ph',
  'magaton@bsp.gov.ph',
  'AgnoNC@bsp.gov.ph',
  'baguila@bsp.gov.ph',
  'MAguila@bsp.gov.ph',
  'AguillonJM@bsp.gov.ph',
  'aaguinaldo@bsp.gov.ph',
  'AgustinAS@bsp.gov.ph',
  'AAla@bsp.gov.ph',
  'malarcon@bsp.gov.ph',
  'alborm@bsp.gov.ph',
  'aldaymt@bsp.gov.ph',
  'alquirozdb@bsp.gov.ph',
  'altamiraaa@bsp.gov.ph',
  'AltamiraKS@bsp.gov.ph',
  'AltoM@bsp.gov.ph',
  'AlvaroAM@bsp.gov.ph',
  'alvarolo@bsp.gov.ph',
  'AlwitZK@bsp.gov.ph',
  'AmonganSH@bsp.gov.ph',
  'AndalRC@bsp.gov.ph',
  'BorjaCA@bsp.gov.ph',
  'AndayaLG@bsp.gov.ph',
  'AndresJG@bsp.gov.ph',
  'AntonioIB@bsp.gov.ph',
  'Antoniojm@bsp.gov.ph',
  'anzuresmc@bsp.gov.ph',
  'aratfg@bsp.gov.ph',
  'rparejola@bsp.gov.ph',
  'ArenasJI@bsp.gov.ph',
  'warguelles@bsp.gov.ph',
  'AritaoDC@bsp.gov.ph',
  'AspirasMG@bsp.gov.ph',
  'astoca@bsp.gov.ph',
  'aatienza@bsp.gov.ph',
  'gaure@bsp.gov.ph',
  'AvilesRB@bsp.gov.ph',
  'OBait-it@bsp.gov.ph',
  'KBalandra@bsp.gov.ph',
  'BaldemoroMU@bsp.gov.ph',
  'ballenapg@bsp.gov.ph',
  'MCuartero@bsp.gov.ph',
  'EFBalot@bsp.gov.ph',
  'BALUNGAYNB@BSP.GOV.PH',
  'BandongSY@bsp.gov.ph',
  'mbangalan@bsp.gov.ph',
  'BansilJK@bsp.gov.ph',
  'BantaJB@bsp.gov.ph',
  'BardelasMC@bsp.gov.ph',
  'barenafq@bsp.gov.ph',
  'baucajr@bsp.gov.ph',
  'BausonMB@bsp.gov.ph',
  'fybautista@bsp.gov.ph',
  'MDBautista@BSP.GOV.PH',
  'BautistaMF@bsp.gov.ph',
  'BautistaRL@bsp.gov.ph',
  'beduyamg@bsp.gov.ph',
  'BelenMD@bsp.gov.ph',
  'belependioak@bsp.gov.ph',
  'bellonfg@bsp.gov.ph',
  'kbelnas@bsp.gov.ph',
  'avbeltran@bsp.gov.ph',
  'RCCastro@bsp.gov.ph',
  'Mnbernabe@bsp.gov.ph',
  'dbernas@bsp.gov.ph',
  'aboco@bsp.gov.ph',
  'sboco@bsp.gov.ph',
  'borresad@bsp.gov.ph',
  'rbrazil@bsp.gov.ph',
  'brillantesam@bsp.gov.ph',
  'ebroqueza@bsp.gov.ph',
  'Buaquinach@bsp.gov.ph',
  'bulanadihg@bsp.gov.ph',
  'rbullecer@bsp.gov.ph',
  'rbumatay@bsp.gov.ph',
  'DeGuzmanDD@bsp.gov.ph',
  'BBunyi@bsp.gov.ph',
  'eburgos@bsp.gov.ph',
  'kcabiltes@bsp.gov.ph',
  'delarajf@bsp.gov.ph',
  'LCaguiat@bsp.gov.ph',
  'EACaguioa@bsp.gov.ph',
  'calazanjs@bsp.gov.ph',
  'calditmr@bsp.gov.ph',
  'CalugtongRR@bsp.gov.ph',
  'camodocgm@bsp.gov.ph',
  'CaoHC@bsp.gov.ph',
  'CaoileMG@bsp.gov.ph',
  'CapiliCC@bsp.gov.ph',
  'CapulSA@bsp.gov.ph',
  'MCaraan@BSP.GOV.PH',
  'carpiopd@bsp.gov.ph',
  'CastanedaJN@bsp.gov.ph',
  'RCCastaneda@bsp.gov.ph',
  'castillanomg@bsp.gov.ph',
  'CastilloMD@bsp.gov.ph',
  'SDCastillo@bsp.gov.ph',
  'CausapinCY@bsp.gov.ph',
  'CayabyabSM@bsp.gov.ph',
  'cendanatr@bsp.gov.ph',
  'ceninajb@bsp.gov.ph',
  'CerreroMB@bsp.gov.ph',
  'ChanGC@bsp.gov.ph',
  'tmatillano@bsp.gov.ph',
  'MChiong@bsp.gov.ph',
  'ChozasEM@bsp.gov.ph',
  'ichua@bsp.gov.ph',
  'ChuanLU@bsp.gov.ph',
  'CondeMG@bsp.gov.ph',
  'ConstantinoGS@bsp.gov.ph',
  'CopiosoAD@bsp.gov.ph',
  'CorderoMC@bsp.gov.ph',
  'CoronelMM@bsp.gov.ph',
  'CortezJT@bsp.gov.ph',
  'jccruz@bsp.gov.ph',
  'CruzRC@bsp.gov.ph',
  'cuarterojp@bsp.gov.ph',
  'cubemp@bsp.gov.ph',
  'mcube@bsp.gov.ph',
  'cuchapinjp@bsp.gov.ph',
  'cuchapinng@bsp.gov.ph',
  'cunananjd@bsp.gov.ph',
  'cuyugansp@bsp.gov.ph',
  'edamasco@bsp.gov.ph',
  'ADamian@bsp.gov.ph',
  'RDancel@BSP.GOV.PH',
  'DarangJP@bsp.gov.ph',
  'DarangJD@bsp.gov.ph',
  'DatudaculaNM@bsp.gov.ph',
  'deguzmanjc@bsp.gov.ph',
  'deguzmanmd@bsp.gov.ph',
  'ConquillaMP@bsp.gov.ph',
  'JSDeJesus@bsp.gov.ph',
  'delapazpa@bsp.gov.ph',
  'desilvasa@bsp.gov.ph',
  'MDeVilla-Go@bsp.gov.ph',
  'decenajo@bsp.gov.ph',
  'garciacc@bsp.gov.ph',
  'RSDelRosario@bsp.gov.ph',
  'TDelRosario@bsp.gov.ph',
  'ndelacena@bsp.gov.ph',
  'DelaCruzMoM@bsp.gov.ph',
  'CDelmendo@bsp.gov.ph',
  'mdetera@bsp.gov.ph',
  'DiamanteMJ@bsp.gov.ph',
  'tupasgt@bsp.gov.ph',
  'DiazJD@bsp.gov.ph',
  'DienteAP@bsp.gov.ph',
  'dimalaluannc@bsp.gov.ph',
  'BarairoAA@bsp.gov.ph',
  'dingalsangd@bsp.gov.ph',
  'DinoKC@bsp.gov.ph',
  'diwaab@bsp.gov.ph',
  'jdizon@bsp.gov.ph',
  'sbdomingo@bsp.gov.ph',
  'DominguianoHC@bsp.gov.ph',
  'DucducanGJ@bsp.gov.ph',
  'CanasaJF@bsp.gov.ph',
  'PinlacLD@bsp.gov.ph',
  'dyry@bsp.gov.ph',
  'EnervaCB@bsp.gov.ph',
  'EnriquezCC@bsp.gov.ph',
  'enriquezea@bsp.gov.ph',
  'EranzoLM@bsp.gov.ph',
  'ErolesMM@bsp.gov.ph',
  'hespinosa@bsp.gov.ph',
  'EspinosaKD@bsp.gov.ph',
  'espiritukd@bsp.gov.ph',
  'lespiritu@bsp.gov.ph',
  'espiriturd@bsp.gov.ph',
  'ievaristo@bsp.gov.ph',
  'falconjd@bsp.gov.ph',
  'MFamilara@BSP.GOV.PH',
  'FelixMF@bsp.gov.ph',
  'felizardorr@bsp.gov.ph',
  'FernandezPT@bsp.gov.ph',
  'FerrerZA@bsp.gov.ph',
  'aferreras@bsp.gov.ph',
  'mflores@bsp.gov.ph',
  'MGRFlores@bsp.gov.ph',
  'FlorescaSJ@bsp.gov.ph',
  'CFonacier@bsp.gov.ph',
  'FranciscoPR@bsp.gov.ph',
  'GACOLMC@bsp.gov.ph',
  'gagahinava@bsp.gov.ph',
  'galanjg@bsp.gov.ph',
  'GalvezMC@bsp.gov.ph',
  'GalvezGP@bsp.gov.ph',
  'agamat@bsp.gov.ph',
  'GamboaRA@bsp.gov.ph',
  'derealmg@bsp.gov.ph',
  'JGarcia@bsp.gov.ph',
  'vgarcia@bsp.gov.ph',
  'GomezGP@bsp.gov.ph',
  'gomezLa@bsp.gov.ph',
  'NunagRZ@bsp.gov.ph',
  'GonzalesRA@bsp.gov.ph',
  'GranadaMG@bsp.gov.ph',
  'GravadorMN@bsp.gov.ph',
  'GrutaGB@bsp.gov.ph',
  'guerreroap@bsp.gov.ph',
  'jguevarra@amlc.gov.ph',
  'NGuinto@bsp.gov.ph',
  'guiruelags@bsp.gov.ph',
  'CCaranto@bsp.gov.ph',
  'GurionPD@bsp.gov.ph',
  'DGustilo@bsp.gov.ph',
  'egutierrez@bsp.gov.ph',
  'GutierrezVN@bsp.gov.ph',
  'HalillulaJV@bsp.gov.ph',
  'HolguinARM@bsp.gov.ph',
  'ResurreccionAS@bsp.gov.ph',
  'HUITJP@bsp.gov.ph',
  'IcaroAT@bsp.gov.ph',
  'aimperial@bsp.gov.ph',
  'golonghm@bsp.gov.ph',
  'RJadulan@bsp.gov.ph',
  'jarquefa@bsp.gov.ph',
  'JimenezCA@bsp.gov.ph',
  'juanjo@bsp.gov.ph',
  'juatcotm@bsp.gov.ph',
  'julianrj@bsp.gov.ph',
  'junsaydd@bsp.gov.ph',
  'ejusto@bsp.gov.ph',
  'KingBS@bsp.gov.ph',
  'LacabaHG@bsp.gov.ph',
  'LadaoAL@bsp.gov.ph',
  'LagansonDM@bsp.gov.ph',
  'LayosRP@bsp.gov.ph',
  'LaysonJP@bsp.gov.ph',
  'LayugAO@bsp.gov.ph',
  'lealjl@bsp.gov.ph',
  'rlegaspi@bsp.gov.ph',
  'catumberta@bsp.gov.ph',
  'LiaoCM@bsp.gov.ph',
  'LibedLO@bsp.gov.ph',
  'jlim@bsp.gov.ph',
  'nlima@bsp.gov.ph',
  'MLizan@bsp.gov.ph',
  'nllaguno@bsp.gov.ph',
  'lomb@bsp.gov.ph',
  'LoriegaCV@bsp.gov.ph',
  'LubiranMB@bsp.gov.ph',
  'blucero@bsp.gov.ph',
  'LumalangHC@bsp.gov.ph',
  'GLuna@BSP.GOV.PH',
  'EamiguelMO@bsp.gov.ph',
  'amabait@bsp.gov.ph',
  'BMacalalag@bsp.gov.ph',
  'rmaddara@bsp.gov.ph',
  'FSantos@bsp.gov.ph',
  'OMagahin@BSP.GOV.PH',
  'maglalangma@bsp.gov.ph',
  'MagnoMA@bsp.gov.ph',
  'SMalabed@bsp.gov.ph',
  'malibiranEJ@bsp.gov.ph',
  'ManalaysayIB@bsp.gov.ph',
  'chuamn@bsp.gov.ph',
  'MMandigma@bsp.gov.ph',
  'chsantos@bsp.gov.ph',
  'ManioCP@bsp.gov.ph',
  'ManuelTA@bsp.gov.ph',
  'MarangaMB@bsp.gov.ph',
  'mgmarasigan@bsp.gov.ph',
  'DMarcelino@bsp.gov.ph',
  'MTMarifosque@bsp.gov.ph',
  'MarquezMM@bsp.gov.ph',
  'AMartinez@bsp.gov.ph',
  'cmartinez@bsp.gov.ph',
  'mbmartinez@bsp.gov.ph',
  'martirezde@bsp.gov.ph',
  'MatiasME@bsp.gov.ph',
  'mmaxilom@bsp.gov.ph',
  'medranoja@bsp.gov.ph',
  'delavictoriaop@bsp.gov.ph',
  'MeraptanNA@bsp.gov.ph',
  'MeraptanRC@bsp.gov.ph',
  'JMercado@bsp.gov.ph',
  'JKMercado@bsp.gov.ph',
  'mercadosa@bsp.gov.ph',
  'merculloav@bsp.gov.ph',
  'emillo@bsp.gov.ph',
  'mirasolgt@bsp.gov.ph',
  'molinama@bsp.gov.ph',
  'smolina@bsp.gov.ph',
  'pmontemayor@bsp.gov.ph',
  'pagaspaslc@bsp.gov.ph',
  'SMusni@bsp.gov.ph',
  'NacpilRA@bsp.gov.ph',
  'NaynesFB@bsp.gov.ph',
  'ONegradas@bsp.gov.ph',
  'nerydm@bsp.gov.ph',
  'MNieva@BSP.GOV.PH',
  'nucomla@bsp.gov.ph',
  'oconnormj@bsp.gov.ph',
  'cofracio@bsp.gov.ph',
  'velascocm@bsp.gov.ph',
  'OidaPL@bsp.gov.ph',
  'olmedillocd@bsp.gov.ph',
  'AOng@bsp.gov.ph',
  'ongjp@bsp.gov.ph',
  'OngRC@bsp.gov.ph',
  'ongtangcoMH@bsp.gov.ph',
  'padillamd@bsp.gov.ph',
  'PascualAA@bsp.gov.ph',
  'PalonponED@bsp.gov.ph',
  'mbparuginog@amlc.gov.ph',
  'mrpascual@bsp.gov.ph',
  'mppascual@bsp.gov.ph',
  'rpasol@bsp.gov.ph',
  'pastranahl@bsp.gov.ph',
  'LEPedrialva@bsp.gov.ph',
  'PedrialvaMT@bsp.gov.ph',
  'pcpelagio@bsp.gov.ph',
  'peregrinors@bsp.gov.ph',
  'corralesat@bsp.gov.ph',
  'GPerez@bsp.gov.ph',
  'pinedaam@bsp.gov.ph',
  'AEPINGOL@BSP.GOV.PH',
  'crobes@bsp.gov.ph',
  'MPlabasan@bsp.gov.ph',
  'ChuaLP@bsp.gov.ph',
  'poloyapoydr@bsp.gov.ph',
  'PradezJG@bsp.gov.ph',
  'PunzalanRG@bsp.gov.ph',
  'hpuyaoan@bsp.gov.ph',
  'quiminalesfa@bsp.gov.ph',
  'quintosrd@bsp.gov.ph',
  'equitoriano@bsp.gov.ph',
  'QuitorianoKF@bsp.gov.ph',
  'racinesalt@bsp.gov.ph',
  'cruzed@bsp.gov.ph',
  'lramolete@bsp.gov.ph',
  'RamosAB@bsp.gov.ph',
  'ramosrc@bsp.gov.ph',
  'arazon@bsp.gov.ph',
  'AdrianoHG@bsp.gov.ph',
  'regunanjb@bsp.gov.ph',
  'reyesmtg@bsp.gov.ph',
  'SomRR@bsp.gov.ph',
  'Reynomf@bsp.gov.ph',
  'bribay@bsp.gov.ph',
  'RicanaCP@bsp.gov.ph',
  'RicoNV@bsp.gov.ph',
  'RIOJAVS@BSP.GOV.PH',
  'RiveraMU@bsp.gov.ph',
  'SRobles@bsp.gov.ph',
  'RodilDA@bsp.gov.ph',
  'RODRIGUEZLG@BSP.GOV.PH',
  'drombawa@bsp.gov.ph',
  'GarciaKR@bsp.gov.ph',
  'dmgarcia@bsp.gov.ph',
  'RubiaCS@bsp.gov.ph',
  'RuizRP@bsp.gov.ph',
  'SabinoRP@bsp.gov.ph',
  'LSSalendrez@bsp.gov.ph',
  'SaltaRL@bsp.gov.ph',
  'SaludMA@bsp.gov.ph',
  'salvadorks@bsp.gov.ph',
  'rtsalvador@bsp.gov.ph',
  'sanpedrodm@bsp.gov.ph',
  'sanchezvf@bsp.gov.ph',
  'santoscy@bsp.gov.ph',
  'cmsantos@bsp.gov.ph',
  'DSantos@bsp.gov.ph',
  'PagtakhanGC@bsp.gov.ph',
  'santosjs@bsp.gov.ph',
  'jmsantos@bsp.gov.ph',
  'jesantos@bsp.gov.ph',
  'SarmientoRN@bsp.gov.ph',
  'SarmientoRT@bsp.gov.ph',
  'SarmientoRF@bsp.gov.ph',
  'SayonAJ@bsp.gov.ph',
  'seguirr@bsp.gov.ph',
  'serranoeuc@bsp.gov.ph',
  'FSolis@bsp.gov.ph',
  'sombeld@bsp.gov.ph',
  'ksoriano@bsp.gov.ph',
  'sottomb@bsp.gov.ph',
  'JSuficiencia@bsp.gov.ph',
  'JSungsai@bsp.gov.ph',
  'csy@bsp.gov.ph',
  'TabaresMD@bsp.gov.ph',
  'cestrella@bsp.gov.ph',
  'TabilogAA@bsp.gov.ph',
  'vichoaj@bsp.gov.ph',
  'TabordaEM@bsp.gov.ph',
  'TabuadaVA@bsp.gov.ph',
  'Tadique-EbuengaRB@bsp.gov.ph',
  'mtagimacruz@bsp.gov.ph',
  'lsison@bsp.gov.ph',
  'tamayojd@bsp.gov.ph',
  'kptambot@bsp.gov.ph',
  'ktan@bsp.gov.ph',
  'TanJT@bsp.gov.ph',
  'TanMI@bsp.gov.ph',
  'TanTH@bsp.gov.ph',
  'GTTaniajura@bsp.gov.ph',
  'JTano@bsp.gov.ph',
  'MTano@bsp.gov.ph',
  'TeeIC@bsp.gov.ph',
  'TejadaS@bsp.gov.ph',
  'TenederoMP@bsp.gov.ph',
  'ntianela@bsp.gov.ph',
  'timkangkg@bsp.gov.ph',
  'dtinaya@amlc.gov.ph',
  'MTiongson@bsp.gov.ph',
  'ibanezaa@bsp.gov.ph',
  'TiuRS@bsp.gov.ph',
  'TolentinoGG@bsp.gov.ph',
  'TolingAB@bsp.gov.ph',
  'ddtonel@bsp.gov.ph',
  'TrinidadK@bsp.gov.ph',
  'GTugade@bsp.gov.ph',
  'tumaliuanmb@bsp.gov.ph',
  'atuminez@bsp.gov.ph',
  'tyct@bsp.gov.ph',
  'UmerezEB@bsp.gov.ph',
  'UnajanFS@bsp.gov.ph',
  'MPUntalan@bsp.gov.ph',
  'UyAD@bsp.gov.ph',
  'uyev@bsp.gov.ph',
  'uyrc@bsp.gov.ph',
  'ValdemorKE@bsp.gov.ph',
  'cvaldez@bsp.gov.ph',
  'dvalencia@amlc.gov.ph',
  'ValenciaSD@bsp.gov.ph',
  'EbareMB@bsp.gov.ph',
  'MVargas@bsp.gov.ph',
  'MAVasquez@bsp.gov.ph',
  'mvehemente@bsp.gov.ph',
  'PVehemente@bsp.gov.ph',
  'AVelasco@bsp.gov.ph',
  'VelascoJF@bsp.gov.ph',
  'vergaravb@bsp.gov.ph',
  'VillanuevaJM@bsp.gov.ph',
  'SantillanTB@bsp.gov.ph',
  'vvillanueva@bsp.gov.ph',
  'BajoMC@bsp.gov.ph',
  'villorentemv@bsp.gov.ph',
  'mvinluan@bsp.gov.ph',
  'SabacJ@bsp.gov.ph',
  'YapAV@bsp.gov.ph',
  'MBYoungJr@bsp.gov.ph',
  'ZuluetaJF@bsp.gov.ph',
  'ZuluetaPF@bsp.gov.ph'
];

const MemberVotingPortal = () => {
  const [email, setEmail] = useState('');
  const [userData, setUserData] = useState(null);
  const [userName, setUserName] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [showInvalidMessage, setShowInvalidMessage] = useState(false);

  const handleEmailChange = event => {
    const emailInput = event.target.value;
    setEmail(emailInput);
    setShowInvalidMessage(false);
    setIsEmailValid(validateEmail(emailInput));
  };

  const validateEmail = email => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleFetchUserData = async () => {
    if (
      !whitelistedEmails
        .map(email => email.toLowerCase())
        .includes(email.toLowerCase())
    ) {
      setShowInvalidMessage(true);
    } else {
      setShowInvalidMessage(false);
      try {
        const data = await getUser({ email: email.toLowerCase() });
        setUserData(data);
        setUserName([data.first_name, data.last_name].join(' '));
        setIsModalOpen(false);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    }
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#007BFF',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
    opacity: isEmailValid ? 1 : 0.5
  };

  return (
    <div style={containerStyle}>
      {isModalOpen && (
        <div style={modalStyle}>
          <div style={modalContentStyle}>
            <h2 style={modalHeaderStyle}>Enter your email</h2>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={handleEmailChange}
              style={inputStyle}
            />
            {showInvalidMessage && (
              <p style={{ color: 'red', fontSize: '12px' }}>
                Invalid email. This member is not eligible to vote.
              </p>
            )}
            <button
              onClick={handleFetchUserData}
              style={buttonStyle}
              disabled={!isEmailValid}
            >
              Submit
            </button>
          </div>
        </div>
      )}
      {userName && <h2 style={welcomeStyle}>Welcome, {userName}!</h2>}
      {userData && <MemberVoting userData={userData} />}
    </div>
  );
};

const containerStyle = {
  padding: '20px',
  fontFamily: 'Arial, sans-serif',
  textAlign: 'center'
};

const modalStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

const modalContentStyle = {
  backgroundColor: 'white',
  padding: '30px',
  borderRadius: '10px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  textAlign: 'center',
  width: '300px'
};

const modalHeaderStyle = {
  marginBottom: '20px',
  color: '#007BFF'
};

const inputStyle = {
  marginBottom: '20px',
  padding: '10px',
  width: '100%',
  borderRadius: '5px',
  border: '1px solid #ccc',
  fontSize: '16px'
};

const welcomeStyle = {
  color: '#007BFF',
  marginTop: '20px'
};

export default MemberVotingPortal;
